import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { TbMessage2Question } from 'react-icons/tb';
import ButtonPrimary from '../../Form/ButtonPrimary';
import Button from '../../Form/Button';
import { useTranslation } from 'react-i18next';

interface EditObservationConferenceProps {
    onConfirm: (value: string) => void;
    onCancel: CallableFunction;
    product: any;
  }

  const EditObservationConference = ({
    onConfirm = () => {},
    onCancel = () => {},
    product
  }: EditObservationConferenceProps) => {

    const { t } = useTranslation();
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [observationUpdated, setObservationUpdated] = useState<string>(product.observation);
    const handleObservation = (event: ChangeEvent<HTMLTextAreaElement>) => {
      const editedObservation = event.target.value.trim();
      setObservationUpdated(editedObservation)
    }

    useEffect(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    }, []);

    return (
      <section className='flex flex-col items-center w-full p-6 gap-6'>
          <h4 className='flex flex-col items-center'>
              <span className='mb-2 text-shopfood-title'><TbMessage2Question size={45} /></span>
              <span className='font-bold text-xl text-shopfood-title'>{t('layout.observation.title')}</span>
              <span className='leading-5 text-lg' dangerouslySetInnerHTML={{__html: product?.name?.replace(/<br\s*\/?>/gi, ' ') ?? ''}} />
          </h4>

          <textarea
              id="observation"
              name="observation"
              ref={textareaRef}
              className={`
                block w-full rounded-md leading-5 border-0 p-2.5 shadow ring-1 ring-gray-300 placeholder:text-gray-300 
                focus:ring-2 focus:ring-custom-primary
                transition-all ease-in-out duration-500
                ${product.observation ? 'h-24' : 'h-16'}
                focus:h-24
              `}
              placeholder={t('layout.observation.placeholder')}
              defaultValue={product.observation}
              onChange={handleObservation}
          />

          <div className='flex justify-center gap-2 w-full'>
              <ButtonPrimary disabled={product.observation === observationUpdated} onClick={() => onConfirm(observationUpdated)} className='w-full'>{t('layout.observation.button_submit.edit')}</ButtonPrimary>
              <Button onClick={() => onCancel()}>{t('layout.confirm.cancel')}</Button>
          </div>
      </section>
    );
};

export default EditObservationConference;
